module.exports = __webpack_public_path__ + "img/tools-auctions.05bb720c.png";